import { type ContainerProps } from '../types';

const handleClick =
	(id: string) =>
	({}, { clickHandler, links }: ContainerProps) => {
		if (!links[id]) {
			return;
		}

		const { iphId, sacUrl } = links[id];

		if (typeof clickHandler !== 'undefined') {
			return clickHandler(iphId);
		}

		window.open(sacUrl, '_blank');
	};

export const actions = {
	handleClick,
};
